import React from 'react';

import { Button } from 'components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from 'components/ui/dialog';
import { useTranslation } from 'react-i18next';
import { useLangNavigate } from 'shared/hooks';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  orderId: number;
};

export function ReviewCompleteModal({ isOpen, onClose, orderId }: Props) {
  const { t } = useTranslation('review');
  const { navigateWithLang } = useLangNavigate();
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="!w-[calc(100vw-48px)] !max-w-[calc(100vw-48px)] rounded-[32px] border-0 bg-white p-8 shadow-[0_4px_22px_rgba(0,0,0,0.12)] md:!w-[430px] md:!max-w-[430px] md:p-[40px_60px]">
        <DialogTitle className="sr-only">{t('writeReview.thankYou')}</DialogTitle>
        <DialogDescription className="sr-only">Review submission complete modal</DialogDescription>

        <div className="flex flex-col items-center gap-[25px]">
          <div className="flex flex-col items-center gap-[8px]">
            <div className="flex flex-col items-center gap-[4px]">
              <div className="h-[50px] w-[50px]">
                <img
                  src="/images/optimized/illusts/il_check.webp"
                  alt="Check icon"
                  className="h-full w-full object-cover"
                />
              </div>

              <h2 className="text-center text-[20px] font-bold leading-[1.4] tracking-[-0.022em] text-[#222222]">
                {t('writeReview.thankYou')}
              </h2>
            </div>

            <p className="text-center text-[14px] font-medium leading-[1.5] tracking-[-0.022em] text-[#8E8E8E]">
              {t('writeReview.thankYouDescription')}
            </p>
          </div>

          <div className="flex h-[40px] w-[164px] items-center justify-center">
            <Button
              onClick={() => {
                onClose();
                navigateWithLang(`/order/${orderId}`);
              }}
              className="h-full w-full rounded-[8px] bg-primary px-[10px] py-[10px] text-[13px] font-semibold leading-[1.5] tracking-[-0.022em] text-white hover:bg-gray-50 hover:bg-primary/90"
            >
              {t('writeReview.orderDetails')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
